<template>
  <div class="modal-goodsClass">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">用药记录添加</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="24" class="item">
                <el-form-item label="药品" required prop="drugName">
                  <el-input v-model="addForm.drugName" placeholder="请输入药品名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="服用开始日期" required prop="beginTime">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="addForm.beginTime" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="服用结束日期" required prop="endTime">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="addForm.endTime" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="用药剂量" required prop="dosage">
                  <el-input v-model="addForm.dosage" placeholder="请输入用药剂量"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="服用疗程" required prop="treatment">
                  <el-input v-model="addForm.treatment" placeholder="请输入服用疗程"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="item">
                <el-form-item label="使用方法" required prop="takeMethod">
                  <el-input v-model="addForm.takeMethod" placeholder="请输入使用方法"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="item">
                <el-form-item label="作用" required prop="remarks">
                  <el-input v-model="addForm.remarks" placeholder="请输入作用"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";
// import Daterange from "@/components/Daterange";

export default {
  name: "Add",
  data() {
    return {
      loading: false,
      addForm: {
        timeStr: timeStr,
        staffCode: getStaffCode(),
        sign: "",
        userCode: "",
        elderlyCode: "",
        drugName: "",
        beginTime: "",
        endTime: "",
        dosage: "",
        treatment: "",
        takeMethod: "",
        remarks: "",
      },
      rules: {
        drugName: [
          { required: true, message: "请输入药品名称", trigger: "blur" },
        ],
        beginTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],
        dosage: [
          { required: true, message: "请输入用药剂量", trigger: "blur" },
        ],
        treatment: [
          { required: true, message: "请输入服药疗程", trigger: "blur" },
        ],
        takeMethod: [
          { required: true, message: "请输入使用方法", trigger: "blur" },
        ],
        remarks: [{ required: true, message: "请输入作用", trigger: "blur" }],
      },
    };
  },

  components: {
    // Daterange,
  },

  methods: {
    init(elderlyCode, userCode) {
      this.$refs.addForm.resetFields();
      this.addForm.elderlyCode = elderlyCode;
      this.addForm.userCode = userCode;
      // this.endTime=timefilters(new Date()).slice(0,10)
      // this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24*30)).slice(0,10)
    },
    closeSelf() {
      this.$emit("closeAdd");
    },
    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSubmit() {
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ETakeDrugs/Add",
        data: this.addForm,
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList", true);
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      });
    },
    dataChange(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
  },
};
</script>




<style lang="scss" scoped>
.modal-goodsClass {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 600px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 100px;
      height: 100px;
    }
    .modal-body .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .modal-body .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .modal-body .avatar {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      display: block;
    }
    .modal-body /deep/ .el-upload--picture-card {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }
    .uploadButton {
      border-top: 1px solid #eee;
      padding: 10px 0 0;
      display: flex;
      .el-button {
        width: 100px;
      }
    }
  }
}

.btn-close,
.btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color: transparent;
}

.row {
  padding: 10px 0px;
}
.item {
  padding: 0px 20px;
}
.label {
  padding: 5px 0px;
}
</style>
